import { errorToast } from "@/v2-ui/toast"
import type { UserFragment } from "@/v2-backoffice-client/user/__types__/user.fragment"
import { useUserStatusUpdateManyMutation } from "@/v2-backoffice-client/user/status/update/many/user.status.update.many.mutation"
import { getActionableUserIds } from "@/v2-backoffice-client/user/status/update/many/user.status.update.many.utils"
import ActionMenu from "@/v2-backoffice-client/components/actionMenu"
import Badge from "@/v2-backoffice-client/components/badge"
import {
  USER_STATUS_UPDATE_ACTIONS,
  USER_STATUS_UPDATE_CODES,
} from "@/v2-backoffice-client/user/status/update/user.status.update.constants"

export type UserStatusUpdateManyMenuProps = {
  users: UserFragment[]
  onCompleted?(): void
}

function UserStatusUpdateManyMenu(props: UserStatusUpdateManyMenuProps) {
  const { users, onCompleted } = props

  const [select, { loading, error }] = useUserStatusUpdateManyMutation()
  errorToast(error, { title: "Failed to update account status" })

  return (
    <ActionMenu>
      <ActionMenu.Trigger
        isStacked
        iconSrc="menu-dots"
        content="Activate, block or remove every selected user at once."
      >
        User Actions
      </ActionMenu.Trigger>

      <ActionMenu.Content>
        <ActionMenu.Label>User Actions</ActionMenu.Label>
        <ActionMenu.Separator />

        {USER_STATUS_UPDATE_CODES.map((code) => {
          const action = USER_STATUS_UPDATE_ACTIONS[code]
          const o = getActionableUserIds(users, code)

          return (
            <ActionMenu.ConfirmItem
              key={code}
              iconSrc={action.iconSrc}
              content={`${action.label} ${o.count} user(s)`}
              variant={action.variant}
              confirmTitle={action.label}
              confirmDescription={`${action.label} ${o.count} user(s)?`}
              confirmText={`${action.label} ${o.count} user(s)`}
              confirmVariant={action.variant}
              disabled={!o.count}
              isLoading={loading}
              onConfirm={() => {
                select({
                  variables: { ids: o.actionableIds, userStatusCode: code },
                  onCompleted,
                })
              }}
            >
              {action.label}

              <Badge
                className="absolute top-1/2 -translate-y-1/2 right-1 text-[8px] rounded-full"
                variant="neutral"
                size="tiny"
              >
                {o.count}
              </Badge>
            </ActionMenu.ConfirmItem>
          )
        })}
      </ActionMenu.Content>
    </ActionMenu>
  )
}

export default UserStatusUpdateManyMenu
